import React from "react";
import Location from "../images/location.svg";
import Mail from "../images/mail.svg";
import Phone from "../images/phone.svg";

export default function Contact() {
  return (
    <div id="section5" className="contact">
      <div className="contact-title">
        <h2>Contact</h2>
      </div>

      <div className="contact-detail">
        <div className="detail">
          <img src={Location} alt="" />
          <h3>Address</h3>
          <p>Rajkot, Gujarat, India - 360006.</p>
        </div>
        <div className="detail">
          <img src={Phone} alt="" />
          <h3>Phone</h3>
          <p>+91 9016700668</p>
        </div>
        <div className="detail">
          <img src={Mail} alt="" />
          <h3>Email</h3>
          <p>Gadhavanaumang007@gmail.com</p>
        </div>
      </div>
    </div>
  );
}
